/* ============================================================
   SimpliPrep theme — theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var burger = document.getElementById('burger');
    var menu = document.getElementById('mobileMenu');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      menu.classList.toggle('open');
      burger.classList.toggle('active');
    });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('open');
        burger.classList.remove('active');
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    document.querySelectorAll('.acc-head').forEach(function (h) {
      h.addEventListener('click', function () {
        h.parentElement.classList.toggle('open');
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery() {
    var mainImg = document.getElementById('mainImg');
    if (!mainImg) return;
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.thumb').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        var src = t.getAttribute('data-img');
        if (src) mainImg.src = src;
      });
    });
  }

  /* ---------- product quantity ---------- */
  function initQuantity() {
    var qty = document.getElementById('qty');
    var plus = document.getElementById('plus');
    var minus = document.getElementById('minus');
    if (!qty) return;
    if (plus) plus.addEventListener('click', function () { qty.value = (+qty.value) + 1; });
    if (minus) minus.addEventListener('click', function () { if (+qty.value > 1) qty.value = (+qty.value) - 1; });
  }

  /* ---------- variant selection (product page) ---------- */
  function initVariants() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var dataEl = document.getElementById('product-variants-data');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selects = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('input[name="id"]');
    var priceNow = document.querySelector('.price-now');
    var addBtn = document.getElementById('addBtn');

    function currentOptions() {
      var opts = [];
      selects.forEach(function (sel) {
        var active = sel.querySelector('.swatch.active') || sel.querySelector('option:checked') || sel;
        if (active && active.dataset && active.dataset.value !== undefined) {
          opts.push(active.dataset.value);
        } else if (sel.value !== undefined) {
          opts.push(sel.value);
        }
      });
      return opts;
    }

    function findVariant() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = window.SimpliPrep.formatMoney(v.price);
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          addBtn.textContent = window.SimpliPrep.strings.addToCart + ' — ' + window.SimpliPrep.formatMoney(v.price);
        } else {
          addBtn.disabled = true;
          addBtn.textContent = window.SimpliPrep.strings.soldOut;
        }
      }
    }

    // swatch buttons
    form.querySelectorAll('[data-option-index] .swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.closest('[data-option-index]');
        group.querySelectorAll('.swatch').forEach(function (x) { x.classList.remove('active'); });
        sw.classList.add('active');
        update();
      });
    });
    // native selects
    form.querySelectorAll('select[data-option-index]').forEach(function (sel) {
      sel.addEventListener('change', update);
    });
  }

  /* ============================================================
     CART
     ============================================================ */
  var Cart = {
    drawer: null,
    open: function () {
      if (this.drawer) this.drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      if (this.drawer) this.drawer.classList.remove('open');
      document.body.style.overflow = '';
    },
    refresh: function () {
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { Cart.render(cart); return cart; });
    },
    add: function (id, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: quantity || 1 }] })
      }).then(function (r) { return r.json(); });
    },
    change: function (key, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) { Cart.render(cart); return cart; });
    },
    render: function (cart) {
      // update bubble count(s)
      document.querySelectorAll('.cart-dot').forEach(function (d) { d.textContent = cart.item_count; });

      var itemsEl = document.getElementById('cart-items');
      var footEl = document.getElementById('cart-foot');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p></div>';
        if (footEl) footEl.style.display = 'none';
        return;
      }
      if (footEl) footEl.style.display = 'block';

      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="cart-line" data-key="' + item.key + '">' +
          '<img src="' + (item.image ? item.image.replace(/(\.[^.]*)$/, '_120x$1') : '') + '" alt="">' +
          '<div class="cl-info">' +
            '<b>' + item.product_title + '</b>' +
            (item.variant_title ? '<span>' + item.variant_title + '</span>' : '') +
            '<div class="cl-qty">' +
              '<button data-action="minus" aria-label="Decrease">\u2212</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-action="plus" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cl-price">' + window.SimpliPrep.formatMoney(item.final_line_price) + '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;

      var sub = document.getElementById('cart-subtotal-val');
      if (sub) sub.textContent = window.SimpliPrep.formatMoney(cart.total_price);

      // free shipping bar
      var bar = document.getElementById('cart-ship');
      if (bar) {
        var threshold = (window.SimpliPrep.freeShipThreshold || 0) * 100;
        if (threshold > 0) {
          var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
          var remaining = threshold - cart.total_price;
          bar.querySelector('.fill').style.width = pct + '%';
          bar.querySelector('.cart-ship-text').textContent = remaining > 0
            ? "You're " + window.SimpliPrep.formatMoney(remaining) + ' away from free shipping'
            : "You've unlocked free shipping \u2713";
        }
      }

      // bind qty buttons
      itemsEl.querySelectorAll('.cart-line').forEach(function (line) {
        var key = line.getAttribute('data-key');
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        line.querySelector('[data-action="plus"]').addEventListener('click', function () { Cart.change(key, item.quantity + 1); });
        line.querySelector('[data-action="minus"]').addEventListener('click', function () { Cart.change(key, item.quantity - 1); });
      });
    }
  };

  function initCart() {
    Cart.drawer = document.getElementById('cart-drawer');
    var cartType = window.SimpliPrep.cartType;

    // open triggers
    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (cartType === 'drawer' && Cart.drawer) {
          e.preventDefault();
          Cart.refresh().then(function () { Cart.open(); });
        }
        // else: it's a normal link to /cart
      });
    });

    if (Cart.drawer) {
      Cart.drawer.querySelector('.cart-overlay').addEventListener('click', Cart.close);
      Cart.drawer.querySelector('.cart-close').addEventListener('click', Cart.close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    }

    // product / quick-add forms
    document.querySelectorAll('form[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (cartType !== 'drawer') return; // let it post normally
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        var submitBtn = form.querySelector('[type="submit"]');
        if (!idInput || !idInput.value) return;
        var original = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) submitBtn.textContent = '\u2713 ' + (window.SimpliPrep.strings.added || 'Added');
        Cart.add(idInput.value, qtyInput ? +qtyInput.value : 1).then(function (res) {
          if (res.status) { // error
            if (submitBtn) submitBtn.textContent = original;
            alert(res.description || 'Could not add to cart');
            return;
          }
          Cart.refresh().then(function () {
            Cart.open();
            if (submitBtn) setTimeout(function () { submitBtn.textContent = original; }, 1200);
          });
        });
      });
    });

    // quick-add buttons (cards using + button, no full form)
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-quick-add');
        if (!id) return;
        var original = btn.textContent;
        Cart.add(id, 1).then(function (res) {
          if (res.status) { alert(res.description || 'Unavailable'); return; }
          btn.textContent = '\u2713';
          btn.classList.add('added');
          if (cartType === 'drawer') {
            Cart.refresh().then(Cart.open);
          } else {
            Cart.refresh();
          }
          setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); }, 1100);
        });
      });
    });

    // keep bubble fresh on load
    if (document.querySelector('.cart-dot')) Cart.refresh();
  }

  /* ---------- product recommendations (fetch + swap grid) ---------- */
  function initRecommendations() {
    document.querySelectorAll('[data-recs-url]').forEach(function (section) {
      var url = section.getAttribute('data-recs-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var freshGrid = parsed.querySelector('.rel-grid');
          var currentGrid = section.querySelector('.rel-grid');
          if (freshGrid && currentGrid && freshGrid.querySelector('.card')) {
            currentGrid.innerHTML = freshGrid.innerHTML;
            initReveal();
            initRecQuickAdd(currentGrid);
          }
        })
        .catch(function () {});
    });
  }

  function initRecQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-quick-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-quick-add');
        if (!id) return;
        var original = btn.textContent;
        Cart.add(id, 1).then(function () {
          btn.textContent = (window.SimpliPrep.strings && window.SimpliPrep.strings.added) || 'Added \u2713';
          btn.classList.add('added');
          setTimeout(function () { btn.textContent = original; btn.classList.remove('added'); }, 1100);
        });
      });
    });
  }

  /* ---------- newsletter inline feedback (Shopify handles the actual submit) ---------- */
  function initNewsletter() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') === 'true') {
      document.querySelectorAll('.news-success').forEach(function (el) { el.style.display = 'block'; });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.SimpliPrep = window.SimpliPrep || {};
    window.SimpliPrep.Cart = Cart;
    initMobileMenu();
    initReveal();
    initAccordions();
    initGallery();
    initQuantity();
    initVariants();
    initCart();
    initRecommendations();
    initNewsletter();
  });
})();
